export interface Permission {
  id: number
  name: string
  description: string
  action: string
  status: boolean
}

export interface Role {
  id?: number
  name: string
  status: number
  created_at: string
  modified_at: string
  deleted_at: string | null
  Permissions: Permission[]
}

export interface QueryState {
  page: number
  perPage: number
  sort?: string
  order?: 'asc' | 'desc'
  filter?: any
  search?: string
  items_per_page?: 10 | 30 | 50 | 100
}

export interface PaginationLink {
  label: string
  active: boolean
  url: string | null
  page: number | null
}

export interface PaginationPayload {
  page: number
  perPage: number
  items_per_page: number
  total: number
  links: PaginationLink[]
}

export interface RolesQueryResponse {
  data: Role[]
  payload: {
    pagination: PaginationPayload
  }
}

export const initialQueryState: QueryState = {
  page: 1,
  perPage: 10,
  sort: '',
  order: 'asc',
  filter: undefined,
  search: ''
} 